import { render, staticRenderFns } from "./WebhookNotifications.vue?vue&type=template&id=5d0c69c2"
import script from "./WebhookNotifications.vue?vue&type=script&lang=js"
export * from "./WebhookNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports